import React from "react";
import { observer } from "mobx-react";
import { EsignatureDocumentViewStore } from "../../store";
import { EsignatureDocumentViewForm } from "./EsignatureDocumentViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type EsignatureDocumentViewProps = {
  esignatureDocumentViewStore: EsignatureDocumentViewStore;
};

export const EsignatureDocumentView: React.FC<EsignatureDocumentViewProps> =
  observer(({ esignatureDocumentViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <EsignatureDocumentViewForm
          externalId={esignatureDocumentViewStore.externalIdValue}
          providerOptions={esignatureDocumentViewStore.getProviderOptions()}
          provider={esignatureDocumentViewStore.providerValue}
          name={esignatureDocumentViewStore.nameValue}
          statusOptions={esignatureDocumentViewStore.getStatusOptions()}
          status={esignatureDocumentViewStore.statusValue}
          sentAt={esignatureDocumentViewStore.sentAtValue}
          completedAt={esignatureDocumentViewStore.completedAtValue}
          signedDocumentFiles={esignatureDocumentViewStore.signedDocumentFiles}
          sourceEntityType={esignatureDocumentViewStore.sourceEntityTypeValue}
          sourceEntityId={esignatureDocumentViewStore.sourceEntityIdValue}
          recipientsVisibleColumns={
            esignatureDocumentViewStore.recipientsVisibleColumns
          }
          recipientsSetColumnWiths={(x) =>
            esignatureDocumentViewStore.recipientsSetColumnWiths(x)
          }
          recipientsRows={esignatureDocumentViewStore.recipientsRowsDyn}
          onPrint={(handlePrint: () => void) =>
            esignatureDocumentViewStore.printEsignatureDocument(handlePrint)
          }
          onCancel={() =>
            esignatureDocumentViewStore.cancelEsignatureDocument()
          }
          onEdit={
            esignatureDocumentViewStore.isEditEnabled
              ? () => esignatureDocumentViewStore.editEsignatureDocument()
              : undefined
          }
          signedDocumentViewAction={getViewAction(
            (props) =>
              esignatureDocumentViewStore.fileDownload(props, "signedDocument"),
            (props) =>
              esignatureDocumentViewStore.viewFilePdf(props, "signedDocument")
          )}
        />
        <ErrorDialog
          open={esignatureDocumentViewStore.errorDialogOpened}
          title={esignatureDocumentViewStore.errorTitle}
          description={esignatureDocumentViewStore.errorDescription}
          onClose={() => esignatureDocumentViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={esignatureDocumentViewStore.pdfViewerOpen}
          onClose={() => esignatureDocumentViewStore.closePdfViewer()}
          pdfUrl={esignatureDocumentViewStore.pdfViewerUrl}
          title={esignatureDocumentViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
